/** Connects cropper positioning and the editor document to the image canvas. */
import React, { forwardRef } from 'react';
import { CropperTransitions, CropperImage, CropperState } from 'react-advanced-cropper';
import { getBackgroundStyle } from 'advanced-cropper';
import { AdjustableImage, DocumentViewProps } from './AdjustableImage';

interface DesiredCropperRef {
   getState: () => CropperState;
   getTransitions: () => CropperTransitions;
   getImage: () => CropperImage;
}

interface Props extends DocumentViewProps {
   className?: string;
   cropper: DesiredCropperRef;
   crossOrigin?: 'anonymous' | 'use-credentials' | boolean;
}

/** Renders the cropper background using the editor's document canvas, positioned and rotated by the cropper. */
export const AdjustableCropperBackground = forwardRef<HTMLCanvasElement, Props>(
   ({ className, cropper, crossOrigin, ...documentProps }: Props, ref) => {
      const state = cropper.getState();
      const transitions = cropper.getTransitions();
      const image = cropper.getImage();

      const style = image && state ? getBackgroundStyle(image, state, transitions) : {};

      return (
         <AdjustableImage
            {...documentProps}
            src={image?.src}
            crossOrigin={crossOrigin}
            ref={ref}
            className={className}
            style={{
               ...style,
               pointerEvents: 'auto'
            }}
            rotation={state?.transforms.rotate}
         />
      );
   },
);
